import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {withFormik} from 'formik';
import yup from 'yup';
import LoginForm from './login-form';
import {setAuthPending} from '../../../redux/actions/auth';
import firebase from '../../../firebase/index';

function mapStateToProps(state) {
	const {
		page: {
			session: {
				isExpired
			} = {}
		} = {},
		auth: {
			unconfirmed,
			authPending
		} = {}
	} = state;

	return {
		isSessionExpired: isExpired,
		isAuthUnconfirmed: unconfirmed,
		isAuthPending: authPending
	};
}

function mapDispatchToProps(dispatch) {
	return {
		setAuthPending(value) {
			dispatch(setAuthPending(value));
		}
	};
}

const schema = yup.object()
	.shape({
		email: yup.string().ensure().required().label('Email'),
		password: yup.string().ensure().required().label('Password')
	});

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	withFormik({
		mapPropsToValues() {
			return schema.cast({});
		},
		handleSubmit(values, {props: {setAuthPending}, setErrors}) {
			const {email, password} = values;

			setAuthPending(true);
			firebase.auth()
				.signInWithEmailAndPassword(email, password)
				.catch(err => {
					setAuthPending(false);
					switch (err.code) {
						case 'auth/wrong-password':
							setErrors({password: err.message});
							break;
						case 'auth/invalid-email':
						case 'auth/user-not-found':
						case 'auth/user-disabled':
						default:
							setErrors({email: err.message});
							break;
					}
				});
		},
		validationSchema: schema
	})
);

export default enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/client/components/admin/login-form/index.js